import { Component, OnInit, Inject } from '@angular/core';
import { Notification } from '../../../configuration/interface';
import { notification } from './modal-confirm';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  standalone: false,
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss']
})
export class ModalConfirmComponent implements OnInit {
  /**
   * TODO: Descripcion de boton Cancelar
   * valor que hace referencia al botón cancelar
   */
  public buttonSecond = 'Cancelar';
  /**
   * TODO: Configuracion de MODAL_CONFIRM
   * valor que son requeridas para configurar el modal
   */
  public description: Notification;

  classButton: any;
  constructor(
    public dialogRef: MatDialogRef<ModalConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    switch (typeof this.data) {
      case 'string':
        this.description = notification[this.data];
        break;
      default:
        this.description = this.data;
        break;
    }
    this.classButton = this.description.color;
  }

  /**
   * TODO: función para CERRAR_MODAL
   * Está función nos ayudara a cerrar directamente el modal
   */
  onClickClose(): void {
    this.dialogRef.close();
  }
}
